<template>
<div class="card" style="height: auto; width: 95%">
    <div class="d-flex justify-content-between align-items-center mb-3" style="padding: 15px">
        <h4>Gift List</h4>
    </div>

    <div class="row">
        <div class="col-md-6">
            <div class="d-flex align-items-center gap-3 p-2 mb-3">

                <img src="@/assets/images/gear/w1.png" alt="wish" style="width: 45px; height: 45px; border-radius: 7px; border: 0.3px solid #4C4036;" />
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="text-secondary mb-0">Capture</p>
                        <p class="text-muted mb-0">&euro;200</p>
                    </div>
                    <p class="role small text-danger mb-0">Peakdesign</p>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="d-flex align-items-center gap-3 p-2 mb-3">

                <img src="@/assets/images/gear/w2.jpg" alt="wish" style="width: 45px; height: 45px; border-radius: 7px; border: 0.3px solid #4C4036;" />
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="text-secondary mb-0">Terms</p>
                        <p class="text-muted mb-0">&euro;200</p>
                    </div>
                    <p class="role small text-danger mb-0">Peakdesign</p>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6">
            <div class="d-flex align-items-center gap-3 p-2 mb-3">

                <img src="@/assets/images/gear/w3.png" alt="wish" style="width: 45px; height: 45px; border-radius: 7px; border: 0.3px solid #4C4036;" />
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="text-secondary mb-0">Tripod</p>
                        <p class="text-muted mb-0">&euro;200</p>
                    </div>
                    <p class="role small text-danger mb-0">Peakdesign</p>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="d-flex align-items-center gap-3 p-2 mb-3">

                <img src="@/assets/images/gear/w4.png" alt="wish" style="width: 45px; height: 45px; border-radius: 7px; border: 0.3px solid #4C4036;" />
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="text-secondary mb-0">Slide</p>
                        <p class="text-muted mb-0">&euro;200</p>
                    </div>
                    <p class="role small text-danger mb-0">Peakdesign</p>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6">
            <div class="d-flex align-items-center gap-3 p-2 mb-3">

                <img src="@/assets/images/gear/w5.jpg" alt="wish" style="width: 45px; height: 45px; border-radius: 7px; border: 0.3px solid #4C4036;" />
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="text-secondary mb-0">Camera</p>
                        <p class="text-muted mb-0">&euro;200</p>
                    </div>
                    <p class="role small text-danger mb-0">Peakdesign</p>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="d-flex align-items-center gap-3 p-2 mb-3">

                <img src="@/assets/images/gear/w6.png" alt="wish" style="width: 45px; height: 45px; border-radius: 7px; border: 0.3px solid #4C4036;" />
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="text-secondary mb-0">Tripod</p>
                        <p class="text-muted mb-0">&euro;200</p>
                    </div>
                    <p class="role small text-danger mb-0">Peakdesign</p>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6">
            <div class="d-flex align-items-center gap-3 p-2 mb-3">

                <img src="@/assets/images/gear/w5.jpg" alt="wish" style="width: 45px; height: 45px; border-radius: 7px; border: 0.3px solid #4C4036;" />
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="text-secondary mb-0">Camera</p>
                        <p class="text-muted mb-0">&euro;200</p>
                    </div>
                    <p class="role small text-danger mb-0">Peakdesign</p>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="d-flex align-items-center gap-3 p-2 mb-3">

                <img src="@/assets/images/gear/w6.png" alt="wish" style="width: 45px; height: 45px; border-radius: 7px; border: 0.3px solid #4C4036;" />
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center">
                        <p class="text-secondary mb-0">Tripod</p>
                        <p class="text-muted mb-0">&euro;200</p>
                    </div>
                    <p class="role small text-danger mb-0">Peakdesign</p>
                </div>
            </div>
        </div>
    </div>
    <div class="button-group">
        <button class="btn" id="view" style="max-width: 130px; margin-left: 5%; margin-bottom: 5%">Share</button>
    </div>
</div>
</template>

<script>
</script>

<style scoped>
</style>
